import { Stack } from "@mui/material";

import FilterPendingBksByLoc from "./filter-pending-bks-by-loc/FilterPendingBksByLoc";
import TablePendingBksByLoc from "./table-pending-bks-by-loc/TablePendingBksByLoc";

/**
 * Content component in tab Pending Bookings by location
 * Contains filter and table
 */
const PendingBksByLocTab = () => {

    return (
        <Stack rowGap={2}  px= {0} py={3}>
            <FilterPendingBksByLoc />
            <TablePendingBksByLoc />
        </Stack>
    );
}

export default PendingBksByLocTab;
